import { useId } from 'react'
import { Box } from '@mui/material'
import FloatingMenuPopup from '@/components/FloatingMenuPopup'
import SettingsSectionIntro from '@/components/Settings/SettingsSectionIntro'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import { SETTINGS_CONNECTION_ROW_MENU_ITEMS } from '@/components/Settings/connectionRowMenuItems'
import shared from '@/components/Settings/settingsShared.module.scss'
import ConnectionsDirectoryHeader from '@/components/Settings/SettingsPageContent/ConnectionsDirectoryHeader'
import ConnectionsDirectoryPanel from '@/components/Settings/SettingsPageContent/ConnectionsDirectoryPanel'
import { useConnectionsDirectoryModel } from '@/components/Settings/SettingsPageContent/useConnectionsDirectoryModel'
import ToolPermissionsDialog from '@/components/Settings/ToolPermissionsDialog'
import { featureFlags } from '@/config/featureFlags'

export default function ConnectionsDirectory() {
  const m = useConnectionsDirectoryModel()
  const connectionsHeadingId = useId()
  const connectionsIntro = getSettingsSectionIntro('connections-directory')
  return (
    <Box component="section" aria-labelledby={connectionsHeadingId} className={shared.connectionsSection}>
      {connectionsIntro ? (
        <SettingsSectionIntro headingId={connectionsHeadingId} lines={connectionsIntro} />
      ) : null}
      <ConnectionsDirectoryHeader
        query={m.query}
        onQueryChange={m.setQuery}
        onAddApp={m.openIntegrations}
      />
      <ConnectionsDirectoryPanel
        listEmpty={m.listEmpty}
        searchNoHits={m.searchNoHits}
        rows={m.filteredConnections}
        menuAnchor={m.menuAnchor}
        menuRowId={m.menuRowId}
        onOpenRowMenu={m.handleOpenRowMenu}
      />
      <FloatingMenuPopup
        open={Boolean(m.menuAnchor)}
        anchorEl={m.menuAnchor}
        onClose={m.handleCloseRowMenu}
        items={featureFlags.connectionsPageV2 ? SETTINGS_CONNECTION_ROW_MENU_ITEMS : SETTINGS_CONNECTION_ROW_MENU_ITEMS.filter((item) => item.id !== 'connection-permissions')}
        onItemSelect={m.handleRowMenuSelect}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        menuListId="connection-row-actions-menu"
        menuListAriaLabel="Connection actions"
      />
      <ToolPermissionsDialog connectionId={m.permissionConnectionId} onClose={m.closePermissions} />
    </Box>
  )
}
